import React, { memo } from 'react'
import { Box, Flex } from 'mds-web-ui'
import { parseDue } from '../utils'
import { getActionHref } from '../utils/href'
import { DeadlineIcon } from './ui/icons'
import { Link } from './ui/Link'
import { width as actionCardWidth } from './ui/ActionCard'

const getDeadlineLabel = (action, date) => {
  const displayDate = parseDue(date).format('MMMM Do')

  return `${action.title} is due on ${displayDate}`
}

const Deadline = ({ action, date }) => (
  <Link
    // my={'2px'}
    py={'1px'}
    // for focus border
    ml={-1}
    pl={1}
    pr={1} // slight larger click target
    role="listitem"
    // we use a label here so we can format the date/time nicely for screen readers
    aria-label={getDeadlineLabel(action, date)}
    to={getActionHref(action)}
    style={{
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',

      '&:focus': {
        outline: 'none',
      },
      '&:focus-visible': {
        borderRadius: '4px',
        boxShadow: '0 0 0 1px var(--text-color)',
      },
    }}
  >
    <Flex alignItems="center" width="fit-content">
      <Box css={{ flexShrink: 0 }}>
        <DeadlineIcon size={11} color="var(--text-color)" />
      </Box>
      <Box
        ml={1}
        color="var(--text-color)"
        fontSize={0}
        lineHeight={1}
        css={{
          flexShrink: 1,
          minWidth: 0,
          // single line of text
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          // minus icon and margin
          maxWidth: actionCardWidth - 11 - 4,
        }}
      >
        {action.title}
      </Box>
    </Flex>
  </Link>
)

const DeadlinesList = memo(({ deadlines, date }) => {
  if (deadlines.length === 0) return null

  return (
    <Box role="list">
      {deadlines.map((action) => (
        <Deadline key={action.identifier} action={action} date={date} />
      ))}
    </Box>
  )
})

export default DeadlinesList
